export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '福建省泉州晋江市金叶国际商厦A区805',
  uc_host: 'http://user.tianjicloud.com',
  site_host: 'http://www.tianjicloud.com',
  special_url: '/',
  site_title: '天极软文发布-软文精准营销平台',
  welcome_title: '天极软文发布 — 软文精准营销平台！',
  site_short_title: '天极软文发布',
  site_subtitle: '软文精准营销平台',
  company_name: '泉州市天极网络科技有限公司',
  copyright: '© 2025 泉州市天极网络科技有限公司',
  logo: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/251102/103c47b36019fb3d67294245b6769c5f.png',
  favicon: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/251102/bdd8e37515d99402c86a922c73f5a01f.png',
  payment: '',
  qq: '453290197',
  tel: '18859526575',
  company_account_id: '1408820109000051745',
  company_bank: '中国工商银行股份有限公司泉州百源支行',
  company_bank_name: '泉州天极网络科技有限公司',
  alipay_account_id: 'pxy@tianjicloud.com',
  alipay_name: '泉州天极网络科技有限公司',
  alipay_pic: '',
  section_id: 5348078,
  belonger_id: 5348078,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 